<!-- FeatherIcon.vue -->
<template>
  <span v-html="iconSvg"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import * as feather from 'feather-icons';

const props = defineProps<{
  icon: string;
  size?: number | string;
  color?: string;
  strokeWidth?: number | string;
  others?: {[key: string]: any};
}>();

const iconSvg = computed(() => {
  const icon = feather.icons[props.icon];
  if (!icon) {
    console.warn(`Icon "${props.icon}" not found in feather-icons.`);
    return '';
  }
  return icon.toSvg({
    width: props.size || 24,
    height: props.size || 24,
    color: props.color || 'currentColor',
    'stroke-width': props.strokeWidth || 2,
    ...(props.others || {})
  });
});
</script>

<style scoped>
span {
  display: inline-block;
  vertical-align: middle;
}
</style>